// Pure coordinate transforms. No THREE deps; vectors are 3-element arrays.
//
// Physical frame (e.g. GSM) -> Three.js frame mapping:
//   physical Y -> three X
//   physical Z -> three Y
//   physical X -> three Z

import type { MutableVec3, Vec3 } from './types';

export type Mat3 = readonly [
  number, number, number,
  number, number, number,
  number, number, number,
];

const IDENTITY3: Mat3 = [1, 0, 0, 0, 1, 0, 0, 0, 1];

let _rotation: Mat3 = [...IDENTITY3] as Mat3;

export function getRotationMatrix(): Mat3 {
  return [..._rotation] as Mat3;
}

export function setRotationMatrix(m9: readonly number[]): void {
  if (!Array.isArray(m9) || m9.length !== 9) {
    throw new Error('setRotationMatrix expects a 9-element row-major array');
  }
  _rotation = [...m9] as unknown as Mat3;
}

export function applyMat3(m: Mat3, v: Vec3): MutableVec3 {
  const [a, b, c, d, e, f, g, h, i] = m;
  const [x, y, z] = v;
  return [a * x + b * y + c * z, d * x + e * y + f * z, g * x + h * y + i * z];
}

export function physicalToThree([x, y, z]: Vec3): MutableVec3 {
  return [y, z, x];
}

export function threeToPhysical([x, y, z]: Vec3): MutableVec3 {
  return [z, x, y];
}

export function mapPhysicalToThreeWithRotation(v: Vec3): MutableVec3 {
  return physicalToThree(applyMat3(_rotation, v));
}
